import moment from "moment";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import MapComponent from "../../Dashboard/MapComponent";

const EventDetailModal = ({ eventDetails, setShowViewModal, sendModalData }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const stars = new Array(5).fill(0);
    const [showMap, setShowMap] = useState(false);
    const [markers, setMarkers] = useState(false);

    useEffect(() => {
        setMarkers([{geocode: eventDetails.geocode}]);
    }, [eventDetails]);


    const handleEventChange = (e, data) => {
        e.preventDefault();
        const value = {"type" : data, "data": eventDetails};
        sendModalData(value);
    }

    return (
        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 flex justify-center items-end sm:items-center z-50">
            <div className="bg-white rounded-t-lg sm:rounded-lg shadow-lg w-[34rem] p-2 sm:p-6 space-y-2 sm:space-y-4">
                <div className="flex justify-between items-center">
                    <div className='sm:flex sm:items-center sm:space-x-2'>
                        <h3 className="text-lg font-semibold capitalize">
                            { t('appointment details')}
                        </h3>
                        <div className={`border-l-4 ${eventDetails.borderColor} ${eventDetails.backgroundColor} p-2 rounded text-xs text-black first-letter:capitalize font-medium`}>
                            {eventDetails.status} {(eventDetails.status === 'completed') && <span>| Actual Time {moment(eventDetails.start).format("HH:mm A")} - {moment(eventDetails.end).format("HH:mm A")}</span>}
                        </div>
                    </div>
                    <button type="button" onClick={() => setShowViewModal(false)} className="text-gray-500 hover:text-gray-700">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"/>
                        </svg>
                    </button>
                </div>
                <div className='space-y-1 sm:space-y-2'>
                    <div className='grid sm:grid-cols-2 gap-2'>
                        <div className='bg-gray-dark3 rounded-md px-2 sm:px-3 py-2 sm:py-2.5 h-full flex sm:grid'>
                            <div className='flex items-start space-x-2'>
                                <img className='w-5 h-5' src="../../assets/icons/profile/icon/type.svg" alt='type' />
                                <label className='hidden sm:block text-xs capitalize text-light-700'>{t('customer name')} :</label>
                            </div>
                            <div className='ml-2 sm:ml-7 text-xs sm:text-sm'>{eventDetails.customername}</div>
                        </div>
                        <div className='bg-gray-dark3 rounded-md px-2 sm:px-3 py-2 sm:py-2.5 h-full flex sm:grid relative'>
                            <div className='flex items-start space-x-2'>
                                <img className='w-5 h-5' src="../../assets/icons/profile/icon/location.svg" alt='location' />
                                <label className='hidden sm:block text-xs capitalize text-light-700'>{t('address')} :</label>
                            </div>
                            <div className='ml-2 sm:ml-7 text-xs sm:text-sm'>{eventDetails.address}</div>
                            <div onClick={(e) => setShowMap(!showMap)} className='absolute z-40 top-1 sm:top-2 right-2 cursor-pointer'>
                                <img className='bg-white p-2 rounded-md shadow-md' src="../../assets/icons/profile/icon/redirect.svg" alt='redirect' />
                            </div>
                        </div>
                    </div>
                    <div className='grid sm:grid-cols-2 gap-2'>
                        <div className='bg-white border border-background-normal rounded-md px-2 sm:px-3 py-2 sm:py-2.5 h-full w-full grid grid-cols-2 sm:grid-cols-1'>
                            <div>
                                <div className='flex items-start space-x-2'>
                                    <img className='w-5 h-5' src="../../assets/icons/profile/icon/calendar.svg" alt='calendar' />
                                    <label className='text-xs capitalize text-light-700'>{t('appointment date')}</label>
                                </div>
                                <div className='ml-7 text-xs sm:text-sm'>{eventDetails.appointmentdate}</div>
                            </div>
                            <div className='hidden sm:block my-3 border-t-2 border-dashed border-background-normal'></div>
                            <div className="flex">
                                <div className='block sm:hidden mx-2 border-l-2 border-dashed border-background-normal h-full'></div>
                                <div>
                                    <div className='flex items-start space-x-2'>
                                        <img className='w-5 h-5' src="../../assets/icons/profile/icon/hour.svg" alt='hour' />
                                        <label className='text-xs capitalize text-light-700'>{t('appointment time')}</label>
                                    </div>
                                    <div className='ml-7 text-xs sm:text-sm'>{moment(eventDetails.appointmentfromtime, "hh:mm:ss").format("HH:mm A")} - {moment(eventDetails.appointmenttotime, "hh:mm:ss").format("HH:mm A")}</div>
                                </div>
                            </div>
                        </div>
                        <div className='bg-white border border-background-normal rounded-md px-2 sm:px-3 py-2 sm:py-2.5 h-full w-full relative grid grid-cols-2 sm:grid-cols-1'>
                            <div>
                                <div className='flex items-start space-x-2'>
                                    <img className='w-5 h-5' src="../../assets/icons/profile/icon/appointment.svg" alt='appointment' />
                                    <label className='text-xs capitalize text-light-700'>{t('appointment type')}</label>
                                </div>
                                <div className='ml-7 text-sm'>
                                    {eventDetails.appointmenttypes.length ? eventDetails.appointmenttypes.map(type => type.title).join(', ') : '--'}
                                </div>
                            </div>
                            <div className='hidden sm:block my-3 border-t-2 border-dashed border-background-normal'></div>
                            <div className="flex">
                                <div className='block sm:hidden mx-2 border-l-2 border-dashed border-background-normal h-full'></div>
                                <div>
                                    <div className='flex items-start space-x-2'>
                                        <img className='w-5 h-5' src="../../assets/icons/profile/icon/briefcase.svg" alt='briefcase' />
                                        <label className='text-xs capitalize text-light-700'>{t('kind of appointment type')}</label>
                                    </div>
                                    <div className='ml-7 text-sm'>
                                        {eventDetails.kindofappointments.length ? eventDetails.kindofappointments.map(type => type.title).join(', ') : '--'}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {(eventDetails.status === 'cancelled') && (
                        <div className='bg-white border border-background-normal rounded-md px-2 sm:px-3 py-2 sm:py-2.5 h-full relative'>
                            <div className='flex items-start space-x-2'>
                                <img className='w-5 h-5' src="../../assets/icons/profile/icon/reason.svg" alt='reason' />
                                <label className='text-xs capitalize text-light-700'>{t('reason for cancellation')}</label>
                            </div>
                            <div className='ml-7 text-xs sm:text-sm'>{eventDetails.cancelreason ? eventDetails.cancelreason : '--'}</div>
                        </div>
                    )}
                    {(eventDetails.status === 'completed') && (
                        <div className='bg-white border border-background-normal rounded-md px-2 sm:px-3 py-2 sm:py-2.5 h-full relative'>
                            <div className='flex items-start space-x-2'>
                                <img className='w-5 h-5' src="../../assets/icons/profile/icon/overview.svg" alt='overview' />
                                <label className='text-xs capitalize text-light-700'>{t('appointment overview')}</label>
                            </div>
                            <div className='ml-7 text-xs sm:text-sm'>--</div>
                        </div>
                    )}
                    {(eventDetails.status === 'completed') && (
                        <div className='bg-white border border-background-normal rounded-md px-2 sm:px-3 py-2 sm:py-2.5 h-full relative'>
                            <div className="flex justify-between items-center">
                                <div className='flex items-start space-x-2'>
                                    <img className='w-5 h-5' src="../../assets/icons/profile/icon/type.svg" alt='type' />
                                    <label className='text-xs capitalize text-light-700'>{t('outcome of the appointment')}</label>
                                </div>
                                {/* <div className="flex items-center">
                                    {stars.map((_, index) => (
                                        <img key={index} className="w-3 sm:w-5 h-3 sm:h-5" src="../../assets/icons/profile/calendar/star.svg" alt="star" />
                                    ))}
                                    <span className="ml-1">5.0</span>
                                </div> */}
                            </div>
                            <div className='ml-7 text-xs sm:text-sm'>--</div>
                        </div>
                    )}
                    <div className='bg-white border border-background-normal rounded-md px-2 sm:px-3 py-2 sm:py-2.5 h-full relative'>
                        <div className='flex items-start space-x-2'>
                            <img className='w-5 h-5' src="../../assets/icons/profile/icon/comment.svg" alt='comment' />
                            <label className='text-xs capitalize text-light-700'>{ t('comment')}</label>
                        </div>
                        <div className='ml-7 text-xs sm:text-sm'>{eventDetails.comment}</div>
                    </div>
                </div>
                {(eventDetails.status === 'pending') && (
                    <div className='grid grid-cols-4 gap-1 text-xs sm:text-base'>
                        <div onClick={(e) => handleEventChange(e, 'complete')} className='bg-gray-dark3 flex items-center justify-center cursor-pointer space-x-2 rounded-l-md p-2'>
                            <img className='w-3 sm:w-5 h-3 sm:h-5 cursor-pointer' src="../../assets/icons/profile/calendar/tick.svg" alt='tick' />
                            <label className='capitalize cursor-pointer'>{t('complete')}</label>
                        </div>
                        <div onClick={(e) => handleEventChange(e, 'reschedule')} className='bg-gray-dark3 flex items-center justify-center cursor-pointer space-x-2 p-2'>
                            <img className='w-3 sm:w-5 h-3 sm:h-5 cursor-pointer' src="../../assets/icons/profile/calendar/clock.svg" alt='clock' />
                            <label className='capitalize cursor-pointer'>{t('reschedule')}</label>
                        </div>
                        <div onClick={(e) => handleEventChange(e, 'copy')} className='bg-gray-dark3 flex items-center justify-center cursor-pointer space-x-2 p-2'>
                            <img className='w-3 sm:w-5 h-3 sm:h-5 cursor-pointer' src="../../assets/icons/profile/calendar/copy.svg" alt='copy' />
                            <label className='capitalize cursor-pointer'>{t('copy')}</label>
                        </div>
                        <div onClick={(e) => handleEventChange(e, 'cancel')} className='bg-gray-dark3 flex items-center justify-center cursor-pointer space-x-2 rounded-r-md p-2'>
                            <img className='w-3 sm:w-5 h-3 sm:h-5 cursor-pointer' src="../../assets/icons/profile/calendar/cross.svg" alt='cross' />
                            <label className='capitalize cursor-pointer'>{t('cancel')}</label>
                        </div>
                    </div>
                )}
                <div className="flex justify-between items-center text-sm sm:text-base">
                    <button type="button" onClick={() => setShowViewModal(false)} className="px-4 py-2 bg-white text-gray-dark4 capitalize font-medium border border-gray-dark4 rounded-lg">
                        { t('close')}
                    </button>
                    <button onClick={(e) => navigate(`/profiles/detail/${eventDetails.customerid}`)} className="px-4 p-2 bg-blue-normal text-white rounded-lg capitalize">
                        { t('go to customer profile')}
                    </button>
                </div>
            </div>
            {(showMap && markers[0].geocode[0]) && (
                <div className="overflow-y-auto overflow-x-hidden bg-blue-300 bg-opacity-50 fixed flex flex-col top-0 right-0 left-0 z-50 justify-center items-center w-full inset-0 max-h-full">
                    <div className="relative p-4 w-full max-w-5xl max-h-full bg-white rounded-lg">
                        <button onClick={(e) => setShowMap(!showMap)} className="absolute right-1 top-1 border border-gray-400 shadow p-3 bg-white z-20 text-gray-400 rounded-full" >
                            <svg className="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
                                <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"/>
                            </svg>    
                        </button>
                        <MapComponent markers={markers} draggable={false} radius={0}/>
                    </div>
                </div>
            )}
        </div>
    );
};

export default EventDetailModal;
